import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dropzone from 'react-dropzone';
// import { get } from 'lodash';
// import EventBus from 'eventing-bus';
import { toast } from 'react-toastify';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReCAPTCHA from 'react-google-recaptcha';
import Upload from '../../../../assets/images/Upload.svg';
import CloseImage from '../../../../assets/images/Icon_x.svg';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getLanguage, getQueryString } from '../../../../utils/params';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getIssues, createIssue } from '../../helps.api';

const FormCreateIssue = props => {
  const { t } = useTranslation();
  const location = useLocation();
  const language = getLanguage(location);
  const recaptchaRef = useRef();
  // const issue_type = [
  //   { value: 1, name: 'Maid' },
  //   { value: 2, name: 'Electricity or water' },
  //   { value: 3, name: 'Furnitures in the house' },
  //   { value: 4, name: 'Security' },
  //   { value: 5, name: 'Other' },
  // ];
  const [issueType, setIssueType] = useState([]);
  const [files, setFiles] = useState([]);
  const [filePreview, setFilePreview] = useState([]);
  const [isShowSubmit, setIsShowSubmit] = useState(false);
  const userInfo = useSelector(state => state.loginData.userInfo);
  const authUserData = JSON.parse(localStorage.getItem('authUserData'));
  const user = userInfo ?? authUserData?.userInfo;
  const [initialValues, setInitialValues] = useState({
    fullName: user?.fullName ?? user?.fullName ?? '',
    phoneNumber: user?.phoneNumber ?? user?.userPhone ?? '',
    email: user?.email ?? user?.userEmail ?? '',
    apartmentName: '',
    address: '',
    description: '',
    issueType: [],
  });
  const emailRegex = /^([0-9a-zA-Z]([+\-_.][0-9a-zA-Z])*)+@([a-zA-Z_]+?\.)+[a-zA-Z]{2,4}$/;

  useEffect(() => {
    props.showLoader();
    getIssues(getQueryString({ language,type: 1  })).then((res) => {
      if (res) {
        setIssueType(res)
      }
      props.hideLoader();
    });
    setInitialValues({
      ...initialValues,
    });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    //eslint-disable-next-line
  }, [language]);

  // useEffect(() => {
  //   const propsId = get(props, 'layout.cityActive.defaultLocationId', null);
  //   setIdLocation(propsId);
  //   setInitialValues({
  //     ...initialValues
  //   })
  //   // return () => reset();
  //   // eslint-disable-next-line
  // }, [props.layout.cityActive]);

  const onSubmit = (values, resetForm) => {
    if (values) {
      props.showLoader();
      const formData = new FormData();
      // formData.append('language', language);
      formData.append('fullName', values.fullName.trim());
      formData.append('phoneNumber', values.phoneNumber);
      formData.append('email', values.email);
      formData.append('apartmentName', values.apartmentName.trim());
      formData.append('address', values.address.trim());
      formData.append('typeId', convertIssueNameToId(values.issueType));
      formData.append('description', values.description);
      files.forEach(file => {
        formData.append('images', file, file.name);
      });
      createIssue(formData).then(res => {
        if (res.status === 'success') {
          onSuccess();
          resetForm();
        } else {
          onError();
        }
        props.hideLoader();
      });
    }
  };

  const convertIssueNameToId = (listIssueType) => {
    if (listIssueType) {
      let listIdIsssueType = [];
      listIssueType.forEach(element => {
        const a = issueType.find(e => e.title === element)
        listIdIsssueType.push(a.id);
      });
      return listIdIsssueType;
    }
  }

  const messageSuccess = (
    <>
      <div>{t('helps.create_issue.feedback_success')}</div>
    </>
  );

  const onSuccess = () => {
    toast.success(messageSuccess, { autoClose: 5000 });
    // reset();
    setIsShowSubmit(false);
    setFiles([]);
    setFilePreview([]);
    recaptchaRef.current.reset();
  };
  const onError = err => toast.error(err, { autoClose: 5000, position: 'bottom-center' });

  const removeImage = index => {
    let filesCopy = [...files];
    filesCopy.splice(index, 1);

    setFiles(filesCopy);

    const images = filesCopy.map(item => URL.createObjectURL(item));
    setFilePreview(images);
  };

  const checkCaptcha = value => {
    if (value) setIsShowSubmit(true);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        fullName: Yup.string().required(t('owner_register.full_name_is_required')),
        phoneNumber: Yup.string()
          .required(t('owner_register.phone_number_is_required'))
          // .matches(emailRegex, 'Phone number is not valid')
          .min(7, t('owner_register.phone_number_min_max'))
          .max(15, t('owner_register.phone_number_min_max')),
        // email: Yup.string().email(t('owner_register.email_is_invalid')).required(t('owner_register.email_is_required')),
        email: Yup.string().required(t('owner_register.email_is_required')).matches(emailRegex, t('owner_register.email_is_invalid')),
        apartmentName: Yup.string().required(t('create_issue.apartment_name_required')),
        address: Yup.string().required(t('create_issue.address_required')),
        issueType: Yup.array().min(1, t('create_issue.issue_type_required')),
      })}
      onSubmit={(values, { resetForm }) => onSubmit(values, resetForm)}
      render={({ errors, touched, setFieldValue }) => (
        <Form className="box-white">
          <h3 className="uppercase form-owner-title">{t('helps.create_issue.customer_information')}</h3>
          <div className="group">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="form-group">
                  <label>
                    {t('helps.create_issue.full_name')} <span className="link-red-bold ">*</span>
                  </label>
                  <Field
                    type="text"
                    className={'form-control' + (errors.fullName && touched.fullName ? ' is-error' : '')}
                    // className="form-control"
                    // placeholder="Nguyen Van Anh"
                    name="fullName"
                    maxLength={191}
                  />
                  <ErrorMessage name="fullName" component="small" className="error" />
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="form-group">
                  <label>
                    {t('helps.create_issue.phone_number')} <span className="link-red-bold ">*</span>
                  </label>
                  <Field
                    type="text"
                    className={'form-control' + (errors.phoneNumber && touched.phoneNumber ? ' is-error' : '')}
                    name="phoneNumber"
                    onChange={event =>
                      setFieldValue(
                        event.target.name,
                        event.target.value
                          .replace(/[^\d/+-]/g, '')
                          .replace(/^([+0-9]{3})([0-9]{3})([0-9]{4})$/, '$1$2$3'),
                      )
                    }
                  />
                  <ErrorMessage name="phoneNumber" component="small" className="error" />
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="form-group">
                  <label htmlFor="email">
                    {t('helps.create_issue.email')} <span className="link-red-bold ">*</span>
                  </label>
                  <Field
                    type="text"
                    className={'form-control' + (errors.email && touched.email ? ' is-error' : '')}
                    // className="form-control"
                    name="email"
                    maxLength={191}
                  />
                  <ErrorMessage name="email" component="small" className="error" />
                </div>
              </div>
            </div>
          </div>
          <h3 className="uppercase form-owner-title">{t('helps.create_issue.apartment_information')}</h3>
          <div className="group">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="form-group">
                  <label>
                    {t('helps.create_issue.apartment_name')} <span className="link-red-bold ">*</span>
                  </label>
                  <Field
                    type="text"
                    className={'form-control' + (errors.apartmentName && touched.apartmentName ? ' is-error' : '')}
                    // className="form-control"
                    placeholder={t('helps.create_issue.apartment_name_please')}
                    name="apartmentName"
                    maxLength={191}
                  />
                  <ErrorMessage name="apartmentName" component="small" className="error" />
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="form-group">
                  <label>
                    {t('helps.create_issue.address')} <span className="link-red-bold ">*</span>
                  </label>
                  <Field
                    type="text"
                    className={'form-control' + (errors.address && touched.address ? ' is-error' : '')}
                    placeholder={t('helps.create_issue.address_for_please')}
                    name="address"
                    maxLength={191}
                  />
                  <ErrorMessage name="address" component="small" className="error" />
                </div>
              </div>
            </div>
          </div>
          <h3 className="uppercase form-owner-title">{t('helps.create_issue.issue_details')}</h3>
          <div className="group">
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label>{t('helps.create_issue.issue_type')} <span className="link-red-bold ">*</span></label>
                  <div className="row">
                    {issueType && issueType.length > 0
                      ? issueType.map((item, index) => {
                        return (
                          <label className="mt-2 col-12 col-md-6 col-lg-3" key={index}>
                            <Field
                              className="issue-type-checked "
                              type="checkbox"
                              name="issueType"
                              value={item.title}
                            />
                            {item.title}
                          </label>
                        );
                      })
                      : ''}
                  </div>
                  <ErrorMessage name="issueType" component="small" className="error" />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <label>{t('helps.create_issue.description_of_issue')}</label>
                  <Field
                    as="textarea"
                    className="form-control w-100 area-owner"
                    name="description"
                    maxLength={500}
                  ></Field>
                </div>
              </div>
            </div>
          </div>
          <div className="group">
            <div className="row">
              <div className="col-12 col-md-12">
                <div className="form-group">
                  <label>{t('helps.create_issue.upload_image')}</label>
                  <Dropzone
                    onDrop={acceptedFiles => {
                      let checkErr = false;
                      let selectedFiles = [];

                      acceptedFiles.forEach(file => {
                        if (file.type.includes('image') && file.size < 2.5e6) {
                          selectedFiles.push(file);
                        } else {
                          checkErr = true;
                        }
                      });

                      if (checkErr) toast.error(t('owner_register.file_image_maximum'));

                      let arrayFiles = [];

                      if (selectedFiles.length + files.length <= 5) arrayFiles = [...files, ...selectedFiles];
                      else arrayFiles = [...files, ...selectedFiles].slice(0, 5);

                      setFiles(arrayFiles);

                      const images = arrayFiles.map(item => URL.createObjectURL(item));
                      setFilePreview(images);
                    }}
                    accept="image/jpeg, image/png, image/jpg, image/gif, image/tiff, image/bmp"
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="drag-drop-files" {...getRootProps()}>
                        <div className="image-upload">
                          <label htmlFor="file-input">
                            <img src={Upload} alt="" />
                            {/* <LazyLoadImage src={Upload} alt="" effect="blur" /> */}
                          </label>
                          <input {...getInputProps()} />
                        </div>
                        <label>{t('helps.create_issue.click_here')}</label>
                        <small>{t('helps.create_issue.supported_image')}</small>
                      </div>
                    )}
                  </Dropzone>
                </div>
                <div className="preview-image">
                  <div className="row">
                    <div className="col-12 col-md-12 image-all">
                      {filePreview.length
                        ? filePreview.map((item, index) => (
                          <div key={index} className="image-selected">
                            <img src={CloseImage} alt="" className="icon-close" onClick={() => removeImage(index)} />

                            <img src={item} alt="" className="image" />

                            {/* <LazyLoadImage
                            src={CloseImage}
                            alt=""
                            className="icon-close"
                            onClick={() => removeImage(index)}
                            effect="blur"
                          />
                          <LazyLoadImage src={item} alt="" className="image" effect="blur" /> */}
                          </div>
                        ))
                        : ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="group">
            <div className="row justify-content-end">
              <div className="col-12 col-md-10 pb-2">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_KEY_CAPTCHA}
                  onExpired={() => {
                    setIsShowSubmit(false);
                  }}
                  onChange={checkCaptcha}
                  hl={`${language === 'en' ? 'en' : language === 'jp' ? 'ja' : 'vi'}`}
                />
              </div>
              <div className="col-12 col-md-2">
                <button id="send" type="submit" className="button-red" disabled={!isShowSubmit}>
                  {t('helps.create_issue.send')}
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    />
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      // fetchForOwnersRequest: action.fetchForOwnersRequest,
      // postInformationRequest: action.postInformationRequest,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(FormCreateIssue);
